/**
 * Simplebar
 */

(function (window) {
  function initScroll() {
    const dataName = '[data-customscrollbar]';
    const scrolls = Array.from(document.querySelectorAll(dataName));
    const options = { autoHide: false };
    const alpineSubTrees = [];
    const simpleBars = [];

    for (let scroll of scrolls) {
      simpleBars.push(new SimpleBar(scroll, options));

      // prep to init Alpine by removing the x-ignore flag
      const alpineIgnored = scroll.closest('[x-ignore]');
      if (alpineIgnored) {
        alpineIgnored.removeAttribute('x-ignore');
        alpineSubTrees.push(alpineIgnored);
      }
    }

    // On next frame: recalculate in one batch (prevents huge gaps in FF)
    // and init Alpine-subtrees once DOM settles
    requestAnimationFrame(function () {
      simpleBars.forEach((s) => s.recalculate());

      if (window.Alpine && 'initTree' in window.Alpine) {
        alpineSubTrees.forEach((r) => window.Alpine.initTree(r));
      }
    });
  }

  initScroll();
})(this);
